import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { SearchIcon } from 'assets/icons';
import { RepairMethodMagnifierButton, SInput } from 'pages/UniversalProductsPage/ProductsPage/ProductsSearch.styled';
import { Flex, Icon } from 'UI';

interface RepairMethodSearchProps {
  filterFunction: (value: string) => void;
}

const RepairMethodSearch = ({ filterFunction }: RepairMethodSearchProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [inputValue, setInputValue] = useState('');

  const onValueChange = useCallback(
    (input: string) => {
      setInputValue(input);
      filterFunction(input);
    },
    [filterFunction],
  );

  const handleClick = useCallback(
    (label: string) => () => {
      if (!label) {
        return;
      }
      setInputValue(label);
    },
    [],
  );

  const handleQueryInputValue = handleClick(inputValue.trim());

  return (
    <SInput
      placeholder={t('catalog.repair_method.search', 'Search')}
      value={inputValue}
      bordered={true}
      onChange={onValueChange}
      onPressEnter={handleQueryInputValue}
      color={theme.color.grey55}
      suffix={
        <Flex>
          <RepairMethodMagnifierButton>
            <Icon
              ml={-8}
              onClick={() => handleClick}
              IconComponent={SearchIcon}
              size={20}
              color={theme.color.grey55}
              background={theme.color.white}
            />
          </RepairMethodMagnifierButton>
        </Flex>
      }
    />
  );
};

export default RepairMethodSearch;
